import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import "./Login.css";

import { ApiError, errorMessage } from "../../api/client";
import { useAuth } from "../../auth/AuthContext";
import StatusMessage, { errorStatus } from "../StatusMessage/StatusMessage";

function loginErrorMessage(err) {
  if (err instanceof ApiError) {
    if (err.status === 401) return "Incorrect username or password.";
    if (err.status === 403) return "This account doesn't have access to the family app.";
  }
  return errorMessage(err, "Login failed.");
}

export default function Login() {
  const { login, status } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = location.state?.from?.pathname ?? "/";

  const [userName, setUserName] = useState("");
  const [passWord, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState(null);

  if (status === "authenticated") return <Navigate to={returnTo} replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage(null);
    try {
      await login(userName, passWord);
      navigate(returnTo, { replace: true });
    } catch (err) {
      setMessage(errorStatus(loginErrorMessage(err)));
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <h1>Login</h1>
      <div className="lefcolumn">
        <div className="header">
          <h2>Family Login</h2>
        </div>
        <div className="card">
          <div className="login">
            <form onSubmit={handleSubmit}>
              <label>
                <p>Username</p>
                <input
                  type="text"
                  autoComplete="username"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                />
              </label>
              <label>
                <p>Password</p>
                <input
                  type="password"
                  autoComplete="current-password"
                  value={passWord}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </label>
              <StatusMessage message={message} />
              <div>
                <button type="submit" disabled={isSubmitting}>
                  {isSubmitting ? "Logging in…" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
